import React from 'react';
import { FadeIn, Section, SectionLabel, Card } from './UI';
const testimonials = [{
  stars: 5,
  quote: 'En menos de dos semanas ya tenía mi LLC aprobada. Nunca pensé que fuera tan fácil con la guía correcta.',
  name: 'Carolina M.',
  location: 'Bogotá, Colombia'
}, {
  stars: 5,
  quote: 'Ya tengo mi empresa y mi cuenta en Mercury funcionando. Esta guía me ahorró meses de confusión.',
  name: 'Roberto V.',
  location: 'Caracas, Venezuela'
}, {
  stars: 5,
  quote: 'Escrita para personas como yo, sin términos legales confusos. La recomiendo 100%.',
  name: 'Daniela R.',
  location: 'Ciudad de México'
}, {
  stars: 5,
  quote: 'Valió cada centavo. En 3 semanas ya estaba facturando desde mi empresa en Florida.',
  name: 'Miguel A.',
  location: 'Miami, Florida'
}];
export const TestimonialsSection = () => {
  return <Section className="bg-sectionAlt" data-id="element-210">
      <FadeIn data-id="element-211">
        <div className="text-center mb-12" data-id="element-212">
          <SectionLabel data-id="element-213">Lo que dicen quienes ya lo hicieron</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline font-bold" data-id="element-214">
            Emprendedores latinos
            <br data-id="element-215" />
            <span className="text-accent" data-id="element-216">con su empresa activa.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-217">
          {testimonials.map((t, i) => <Card key={i} className="p-7 hover:border-accent/40 transition-colors" data-id="element-218">
              <div className="text-[1.1rem] mb-4 tracking-wider text-gold" data-id="element-219">
                {'★'.repeat(t.stars)}
              </div>
              <p className="text-[1.05rem] text-body italic mb-6 leading-relaxed" data-id="element-220">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 pt-5 border-t border-cardBorder" data-id="element-221">
                <div className="w-11 h-11 rounded-full bg-deepPurple text-white flex items-center justify-center font-serif font-bold text-[1.1rem]" data-id="element-222">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-223">
                  <p className="font-bold text-headline text-[0.95rem]" data-id="element-224">
                    {t.name}
                  </p>
                  <p className="text-[0.85rem] text-body" data-id="element-225">{t.location}</p>
                </div>
              </div>
            </Card>)}
        </div>
      </FadeIn>
    </Section>;
};